import { Controller, useFormContext } from "react-hook-form";
import { Input, InputProps } from "./input";

export type ControlledInputProps = Omit<
  InputProps,
  "onValueChange" | "errorMessage"
> & {
  name: string;
};

export function ControlledInput(props: ControlledInputProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field, fieldState }) => {
        return (
          <Input
            {...field}
            onValueChange={field.onChange}
            {...props}
            errorMessage={fieldState?.error?.message}
            isInvalid={!!fieldState?.error?.message}
          />
        );
      }}
    />
  );
}
